import { render, staticRenderFns } from "./combinations.vue?vue&type=template&id=1411af19&scoped=true"
import script from "./combinations.vue?vue&type=script&lang=js"
export * from "./combinations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1411af19",
  null
  
)

export default component.exports